import { tenantRouterRestClient } from 'APP/restApi/restClient/restClient';

export const getDeeplinkRouting = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return tenantRouterRestClient.post(
    'tenants/deeplink',
    {
      body: data,
    },
    'getDeeplinkRoutingRequest'
  );
};

export const getDestinationBaseUrl = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return tenantRouterRestClient.post('discover/baseUrl', { body: data });
};

export const getDiscoverDestinationsRequest = (data: ArrayBufferView): Promise<ArrayBuffer> => {
  return tenantRouterRestClient.post('discover', { body: data });
};
